import { ReactNode } from 'react';
import { cx } from '@/utils/cx';

interface StepperStepProps {
    stepNumber: number;
    title: string;
    description?: string;
    isActive: boolean;
    isCompleted: boolean;
    isValid: boolean;
    children: ReactNode;
    className?: string;
}

export const StepperStep = ({
    stepNumber,
    title,
    isActive,
    children,
    className
}: StepperStepProps) => {
    if (!isActive) {
        return null;
    }

    return (
        <div className={cx("space-y-6", className)}>
            {/* Step Header */}
            <div className="space-y-2">
                <div className="flex items-center gap-3">
                    <span className="text-sm font-medium text-brand-solid">
                        Step {stepNumber}
                    </span>
                    <div className="flex-1 h-px bg-secondary"></div>
                </div>
                <div>
                    <h2 className="text-xl font-semibold text-primary">{title}</h2>
                </div>
            </div>

            {/* Step Content */}
            <div className="space-y-6">
                {children}
            </div>
        </div>
    );
};
